// extracted by mini-css-extract-plugin
export default {"cls1":"wtSKdM1b1FyanBOyBp7l","cls2":"qGSR0wcSgP149AKjlLzK wtSKdM1b1FyanBOyBp7l"};